export const guestComps = {
  detail: {
    nav: {
      overview: "Information",
      bookings: "Bookings",
      checkins: "Check-ins",
      invoicing: "Invoicing",
    },
    personalInfo: "Personal information",
    contactInfo: "Contact information",
    residenceInfo: "Residence information",
    fields: {
      firstName: "First name",
      lastName: "Last name",
      document: "Document",
      nationality: "Nationality",
      country: "Country",
      birthDate: "Date of birth",
      email: "Email",
      whatsapp: "WhatsApp",
      countryResidence: "Country of residence",
      cityResidence: "City of residence",
      relationship: "Relationship",
    },
    cols: {
      code: "Code",
      accommodation: "Accommodation",
      checkIn: "Check-in",
      checkOut: "Check-out",
      status: "Status",
      total: "Total",
      guest: "Guest",
      booking: "Booking",
      entryDate: "Entry date",
      date: "Date",
    },
    confirmed: "Confirmed",
    fiscalProfile: "Registered tax profile",
    legalName: "Legal name",
    taxId: "Tax ID",
    type: "Type",
    company: "Company",
    individual: "Individual",
    invoicesIssued: "Issued invoices",
    empty: {
      bookings: "No bookings recorded for this guest.",
      checkins: "No check-ins recorded for this guest.",
      invoices: "No invoices issued for this guest.",
    },
    noPdf: "No PDF",
    status: {
      sent: "Issued",
      processing: "Processing",
      error: "Error",
      pending: "Pending",
    },
    close: "Close",
  },
  form: {
    editTitle: "Edit client",
    newTitle: "New client",
    subtitle: "Contact and billing details for upcoming bookings and invoices.",
    subtitleEmbedded: "Complete the profile and you'll return to the invoice without losing the charges.",
    backToInvoice: "Back to invoice",
    close: "Close",
    customerTypeAria: "Client type",
    typeIndividual: "Individual",
    typeIndividualHelp: "Natural person",
    typeCompany: "Company",
    typeCompanyHelp: "Legal entity",
    identity: "Identity",
    identityDesc: "Details that identify the invoice recipient.",
    name: "First name",
    namePlaceholder: "John",
    lastName: "Last name",
    lastNamePlaceholder: "Smith",
    legalName: "Legal name",
    legalNamePlaceholder: "Example Company Ltd.",
    docTaxId: "NIF / CIF / VAT",
    docFiscal: "Tax document",
    docPlaceholderIndividual: "DNI, NIE or passport",
    docType: "Document type",
    select: "Select",
    docDni: "DNI",
    docNie: "NIE",
    docPassport: "Passport",
    docOther: "Other document",
    contact: "Contact",
    contactDesc: "Channels to send the invoice or contact the client.",
    email: "Email",
    emailPlaceholder: "customer@email.com",
    phone: "Phone",
    fiscalAddress: "Tax address",
    fiscalAddressDesc: "Used as the recipient's address on a full invoice.",
    country: "Country",
    address: "Address",
    addressPlaceholder: "Street, number and floor",
    city: "City",
    cityPlaceholder: "Madrid",
    state: "Province / State",
    postalCode: "Postal code",
    postalPlaceholder: "28001",
    requiredNote: "* Fields required for the tax profile",
    backToInvoiceShort: "Back to invoice",
    cancel: "Cancel",
    saving: "Saving…",
    saveChanges: "Save changes",
    createClient: "Create client",
    err: {
      name: "Enter the first name.",
      lastName: "Enter the last name.",
      legalName: "Enter the legal name.",
      taxId: "Tax identification is required for companies.",
      country: "Select the country.",
      address: "Enter the tax address.",
      city: "Enter the city.",
      postalCode: "Enter the postal code.",
      email: "Enter a valid email.",
      saveFailed: "The client could not be saved.",
    },
  },
  list: {
    title: "Billing clients",
    subtitle: "Reusable tax profiles for issuing and reviewing invoices",
    searchLabel: "Search clients",
    searchPlaceholder: "Name, email, phone or document…",
    clearSearch: "Clear search",
    exporting: "Exporting...",
    exportClients: "Export clients",
    newClient: "New client",
    cols: {
      fiscalClient: "Fiscal client",
      contact: "Contact",
      fiscalDocument: "Tax document",
      country: "Country",
      linkedBookings: "Linked bookings",
      invoices: "Invoices",
      actions: "Actions",
    },
    company: "Company",
    individual: "Individual",
    noEmail: "No email assigned",
    noPhone: "No phone assigned",
    viewInvoicesTitle: "View {count} invoice for this guest | View {count} invoices for this guest",
    invoicesCount: "{count} invoice | {count} invoices",
    noInvoices: "No invoices",
    editClient: "Edit client",
    edit: "Edit",
    viewDetail: "View detail",
    view: "View",
    emptySearchTitle: "No tax profiles found",
    emptySearchSub: "No billing clients match “{term}”.",
    emptyTitle: "No billing clients yet",
    emptySub: "Create a tax profile when issuing an invoice, or save one now to reuse it later.",
    createFirst: "Create first client",
    selectedClient: "Selected client",
  },
  internalName: {
    addBtn: "internal name",
    title: "Internal name",
    hint: "Only you can see it. It appears before the public name in your lists and calendars.",
    removeWarn: "It will be removed from your lists. Access-code messages and the AI Agent will no longer indicate which accommodation it refers to.",
    edit: "Edit",
    cancel: "Cancel",
    removing: "Removing…",
    confirmRemove: "Yes, remove",
    remove: "Remove",
    editTitle: "Edit internal name",
    addTitle: "Add internal name",
    eyebrow: "Accommodation internal name",
    modalHint: "A private name so you can recognize the accommodation at a glance (for example «Roser Attic» or «Second»). Your guests never see it.",
    placeholder: "Roser Attic",
    previewLabel: "You'll see it like this",
    saving: "Saving…",
    save: "Save",
    saveFailed: "The internal name could not be saved.",
  },
};
